import { validate, Contains, IsInt, MinLength, Min, Max, IsEmail, IsOptional, IsNumberString, Length } from 'class-validator';

export class Usuario {
    @MinLength(1)
    Login: string;
    Password: string;
    @Length(1, 100)
    Nombre: string;
    @MinLength(9)
    Telefono1: string;

    @IsOptional()
    @MinLength(9)
    Telefono2: string;

    @IsEmail()
    EMail: string;
    EFactura: boolean;
    UltimoPeriodoAvisado: string;
    FechaRegistro: Date;
    UltimoAcceso: Date;
    PenultimoAcceso: Date;
    ModoTest: boolean;
    DatePassword: Date;
}


// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/entities/usuario.entity.ts